'use client';

import { TPapelMensagem } from '@/domain/agente/interfaces/agente';
import { cn } from '@/lib/utils';

interface IMensagemBubbleProps {
  papel: TPapelMensagem;
  texto: string;
}

export function MensagemBubble({ papel, texto }: IMensagemBubbleProps) {
  const isUser = papel === 'usuario';

  return (
    <div className={cn('flex animate-fade-in-up', isUser ? 'justify-end' : 'justify-start')}>
      <div
        className={cn(
          'max-w-[85%] whitespace-pre-wrap rounded-2xl px-4 py-2.5 text-sm leading-relaxed',
          isUser ? 'rounded-br-sm bg-brand text-brand-fg' : 'rounded-bl-sm bg-muted text-foreground',
        )}
      >
        {texto}
      </div>
    </div>
  );
}
